// Loads the FULL payload (confidence scores + 720-day series) for one item when its popup opens.
// Separate from nsbFlavorsCache so that module stays a leaf and every renderer can import it.
import { fetchSmartBaselineFlavorsFull, NsbFlavorsResponse } from '@api/SmartBaselineFlavorsApi';
import { getCachedFlavors, hasFullCachedFlavors, setCachedFlavors } from './nsbFlavorsCache';

const inflight = new Map<string, Promise<NsbFlavorsResponse | null>>();

/**
 * One in-flight request per cache key, so two popups on the same item share a single fetch.
 * Resolves null when nothing came back, so the caller can show "no data" instead of a stuck spinner.
 */
export const ensureFullFlavors = (
  cacheKey: string,
  itemNameToUse: string,
  catName?: string | null,
): Promise<NsbFlavorsResponse | null> => {
  if (hasFullCachedFlavors(cacheKey)) return Promise.resolve(getCachedFlavors(cacheKey));

  const existing = inflight.get(cacheKey);
  if (existing) return existing;

  const promise = fetchSmartBaselineFlavorsFull(itemNameToUse, catName)
    .then(result => {
      if (result?.precomputes) setCachedFlavors(cacheKey, result);
      return result?.precomputes ? result : null;
    })
    .finally(() => { inflight.delete(cacheKey); });

  inflight.set(cacheKey, promise);
  return promise;
};
